module.exports = __webpack_public_path__ + "cf759fb6f3c26a56bfa32759eb404427.svg";